import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import RecalProcessAndGenContMain from "presentation/view/container/Recalculation/RecalProcessAndGenContMain";

CommonEntrypoint(<RecalProcessAndGenContMain/>)